import type { ThirdPartyObservableScript } from '@/main/entities/Utils';

// TODO: Add the array of scripts where the error handler will be applied
// ex: export const ObservableScripts = [{inSrc: 'https://api.queryly.com', scriptSeverity: AppErrorSeverity.NORMAL, name: 'Queryly',}];
export const ObservedScripts: ThirdPartyObservableScript[] = [];
